const moment = require('moment-timezone')
import getApiClient from '@/plugins/api-client'

export default {
  openRefundForm: function () {
    this.refundFormOpen = true
  },

  setDisplayDate() {
    this.refundForm.displayDate = moment(this.refundForm.date).format('DD/MM/YYYY')
  },

  validateDate: function () {
    if (this.refundForm.displayDate) {
      let parsedDate = this.parseDate(this.refundForm.displayDate)

      if (moment(parsedDate).isValid()) {
        return this.refundForm.displayDate
      } else {
        this.refundForm.displayDate = null
        this.refundForm.date = null
      }
    }

    return null
  },

  parseDate: function (date) {
    if (date) {
      let splittedDate = date.split('/'),
        year = splittedDate[2],
        month = splittedDate[1],
        day = splittedDate[0]

      return `${year}-${month}-${day}`
    }

    return null
  },

  openRefundFormAttachment: function () {
    this.$refs['refundFormAttachment'].click()
  },

  setRefundFormFile: function ($event) {
    if ($event.target.files && $event.target.files[0]) {
      const file = $event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        this.refundForm.file = e.target.result;
      };

      reader.readAsDataURL(file);
    }
  },

  sendRefund: function () {
    const self = this
    self.$store.state.loading = true

    const postData = JSON.parse(JSON.stringify(self.refundForm))
    postData.date = self.parseDate(postData.displayDate)
    postData.job = self.job['@id']

    if (!postData.date) {
      delete postData.date
    }

    if (!postData.amount) {
      delete postData.amount
    }

    if (postData.overtime) {
      postData.type = 'overtime'
      delete postData.file
    }

    self.errors = {
      description: null,
      date: null,
      amount: null,
      file: null
    }

    const api = getApiClient(self.$store)

    api.post('refunds', postData)
      .then(result => {
        self.$emit('refundSent', result.data)

        self.refundForm = {
          description: '',
          overtime: false,
          date: '',
          displayDate: '',
          amount: null,
          file: null,
        }
      })
      .catch(error => {
        let response = error.response
        switch (response.status) {
          case 400:
          case 422:
            if (error.response.data.violations) {
              error.response.data.violations.forEach((violation) => {
                self.errors[violation.propertyPath] = violation.message
              })
            }
            break;
          default:
            self.showErrorMessage('Ocorreu um erro ao enviar a solicitação de reembolso')
            break;
        }
      })
      .finally(() => {
        self.$store.state.loading = false
      })
  },

  openRefundFile: function (refund) {
    const url = `${process.env.VUE_APP_API_URL}${refund['@id']}/file`
    window.open(url, '_blank')
  },

  confirmDeleteRefund: function (refund) {
    this.refundToDelete = refund
  },

  deleteRefund: function () {
    if (this.refundToDelete) {
      const self = this
      self.$store.state.loading = true
      const api = getApiClient(self.$store)

      api.delete(self.refundToDelete['@id'])
        .then(() => {
          self.$emit('deletedRefund')
        })
        .finally(() => {
          self.$store.state.loading = false
          self.refundToDelete = null
        })
    }
  },

  showErrorMessage: function (message) {
    const self = this

    self.errorMessage.content = message
    self.errorMessage.show = true
  },

  showSuccessMessage: function (message) {
    const self = this

    self.successMessage.content = message
    self.successMessage.show = true
  },
}
